import(/* webpackMode: "eager" */ "/home/runner/work/kanril_web/kanril_web/app/_components/atoms/Spinner.tsx");
import(/* webpackMode: "eager" */ "/home/runner/work/kanril_web/kanril_web/app/_components/AuthFallback.tsx")